module.exports = __webpack_public_path__ + "components/flag/static/square/tn-7dd03c2061cef27ae205b41d69f711b1.svg";